<script setup>
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
defineEmits(["toggleLanguageModal"]);
</script>

<template>
    <div class="bottom-line">
        <div class="left">
            <NuxtLink
                class="cmp-link"
                to="https://brakson.com"
                :title="$t('footer.chargemap')"
                external
                target="_blank"
            >
                {{ $t("footer.chargemap") }}
            </NuxtLink>
            <NuxtLink
                class="cmp-link"
                :to="'javascript:Didomi.preferences.show()'"
                :title="$t('word.consent_choices')"
            >
                {{ $t("word.consent_choices") }}
            </NuxtLink>
            <NuxtLink
                class="cmp-link"
                external
                :to="`/${language}-${country}/about/legal`"
                :title="$t('word.legals')"
            >
                {{ $t("word.legals") }}
            </NuxtLink>
            <NuxtLink
                class="cmp-link"
                external
                :to="`/${language}-${country}/about/privacy-policy`"
                :title="$t('footer.privacy_policy')"
            >
                {{ $t("footer.privacy_policy") }}
            </NuxtLink>
        </div>

        <NuxtLink
            class="cmp-link cmp-link__language items-center gap-1"
            to="#"
            :title="$t('word.language')"
            @click.prevent="$emit('toggleLanguageModal')"
        >
            <IconWorld class="size-4" />
            <span class="font-normal">{{ $t("word.language") }}</span>
            <span class="font-bold">
                {{ language.toLowerCase() }}-{{ country.toUpperCase() }}
            </span>
            <IconChevronDown class="size-4" />
        </NuxtLink>
    </div>
</template>

<style scoped>
.bottom-line {
  @apply bg-sky-500 gap-4 flex flex-col md:flex-row px-4 md:px-6 lg:px-[50px] w-full items-center overflow-hidden justify-between py-6 md:py-3;
}
.bottom-line .cmp-link {
  @apply flex text-white hover:text-white active:text-white focus:text-white active:font-semibold whitespace-nowrap text-ellipsis hover:underline focus:underline text-[13px] lg:text-[15px];
  letter-spacing: -0.13px;
}
.bottom-line .cmp-link__language {
  @apply hidden md:flex;
}
.bottom-line > .left {
  @apply flex flex-col md:gap-4 lg:gap-12 md:flex-row gap-2 items-center;
}
</style>
